import { Building } from "@/components/building";
import { FinderAgentFi } from "@/components/finders/finder-AgentFi";
import { FinderHoldBerachain } from "@/components/finders/finder-bera";
import { FinderBeraStater } from "@/components/finders/finder-bera-starter";
import { FinderBeraIsLand } from "@/components/finders/finder-berAisLand";
import { FinderCommunity } from "@/components/finders/finder-community";
import { FinderDapp } from "@/components/finders/finder-dapp";
import { FinderDeFutures } from "@/components/finders/finder-defutures";
import { FinderHoldCommunity } from "@/components/finders/finder-hold-community";
import { FinderSocial } from "@/components/finders/finder-social";
import { FinderSwap } from "@/components/finders/finder-swap";
import { FinderWallet } from "@/components/finders/finder-wallet";
import { FinderZkStarter } from "@/components/finders/finder-zkstarter";
import Image from "@/components/Image";
import bg3Image from "@/assets/bg/bg3.png";

import { cn } from "@/utils";
import { useResize } from "@/utils/useResize";
import { cva } from "class-variance-authority";

const variants = cva("w-full", {
    variants: {
        twSize: {
            xs: "max-w-[100%]",
            sm: "max-w-[100%]",
            md: "max-w-[768px]",
            lg: "max-w-[1024px]",
            xl: "max-w-[1280px]",
            "2xl": "max-w-[1360px]",
            "3xl": "max-w-[1440px]",
        },
    },
    defaultVariants: {
        twSize: "2xl",
    },
});


export default function HomePage() {
    return (
        <>
            <div className="fixed inset-0 z-[5]">
                <Image
                    src={bg3Image}
                    alt="game"
                    className="w-full h-full object-cover"
                />
            </div>
            <video
                className="fixed inset-0 z-10 object-cover w-screen h-screen"
                autoPlay
                loop
                src="https://static.holdstation.com/videos/Hold_Transition.mp4"
                controls={false}
                playsInline={false}
                muted={true}
            />

            <div className="w-full relative z-50 scroll-container">
                <div
                    className="w-full overflow-hidden"
                    style={{
                        // backgroundImage: "url(/bg/bg1.png)",
                        backgroundRepeat: "no-repeat",
                        backgroundAttachment: "scroll, local",
                        backgroundSize: "cover",
                        backgroundPosition: "bottom center",
                    }}
                >
                    <div className="w-full pb-11 pt-8">
                        <WrapperHome>
                            <FinderHoldCommunity />
                            <FinderCommunity />
                            <FinderSocial />
                            <FinderHoldBerachain />
                            <FinderBeraIsLand />
                            <FinderBeraStater />
                            <FinderAgentFi />
                            <FinderWallet />
                            <FinderSwap />
                            <FinderDeFutures />
                            <FinderDapp />
                            <FinderZkStarter />
                        </WrapperHome>
                    </div>
                </div>
                <div
                    className="h-20 -mt-20 -mb-1"
                    style={
                        {
                            // background: "linear-gradient(0, #071535 20.19%, rgba(20, 38, 76, 0.00) 100%)",
                        }
                    }
                ></div>
                <div
                    className="w-full overflow-hidden pb-8 -mb-8"
                    style={{
                        // backgroundImage: "url(/bg/bg2.png)",
                        backgroundRepeat: "no-repeat",
                        backgroundAttachment: "scroll, local",
                        backgroundSize: "cover",
                        // backgroundColor: "#071535",
                    }}
                >
                    <WrapperHome>
                        <Building />
                    </WrapperHome>
                </div>
                <div
                    className="w-full overflow-hidden -mb-36"
                    style={{
                        // backgroundImage: "url(/bg/bg3.png)",
                        backgroundRepeat: "no-repeat",
                        backgroundAttachment: "scroll, local",
                        backgroundSize: "cover",
                        backgroundPosition: "top center",
                    }}
                >
                    <div
                        className="w-full overflow-hidden"
                    >
                        <WrapperHome>
                            <div className="w-full min-h-[480px] sm:min-h-[600px] md:min-h-[700px]">
                                <div className="flex flex-col mt-[136px] sm:mt-[223px] md:mt-[320px] lg:mt-[280px] xl:mt-[320px] 2xl:mt-[380px] items-center">
                                    <p className="text-white/65 text-2xl font-medium leading-snug uppercase">
                                        To The moon
                                    </p>
                                    <p
                                        className="text-white text-[40px] sm:text-5xl md:text-[64px] font-medium leading-tight mt-2"
                                        style={{
                                            textShadow: "0px 4.581px 9.161px rgba(0, 0, 0, 0.12)",
                                        }}
                                    >
                                        HOLDSTATION
                                    </p>
                                </div>
                            </div>
                        </WrapperHome>
                    </div>
                </div>
            </div>
        </>
    );
}





export function WrapperHome({
    children,
}: Readonly<{
    children: React.ReactNode;
}>) {
    const { twSize } = useResize();

    return <div className={cn(variants({ twSize: twSize }), "w-full mx-auto")}>{children}</div>;
}
